export const BRAND = 'PredictIt';

export default {
  data() {
    return {
      brand: BRAND,
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/brand-name/brand-name.js